import Input from '../General/Input'
import styled from 'styled-components'
import Button from '../General/Button'
import EnquiryForm from '../Layout/EnquiryForm'
import { useDispatch, useSelector } from 'react-redux'
import { getAPIList, submitEnquiry, getCertificateList, openEnquiryModal, getPharmacopoeiaGrades } from '../../store/CoreSlice'
import { useState, useEffect } from 'react';
import enquiryFormSchema from '../../validations/Enquiry';
import { useFormik } from 'formik';
import EnquirySuccess from '../Layout/EnquirySuccess';
import { setFileData } from '../../store/CoreSlice';
import TextArea from '../General/TextArea';
import { ShortEnquiryFormSchema } from '../../validations/Enquiry'

const StyledQuantitySuffix = styled.div`
	border-radius : 4px;
	width : 35px;
	height : 35px;
	background : transparent;
	color : #384C9A;
`



function ShortEnquiry({ firstHeading, secondHeading, subText } : any) {
	let initialValues: { [k: string]: any } = {

		// Autocomplete fields
		product_string : '',

		// Main fields
		product : null,
		product_text : '',
		quantity: null,
		unit: 1,
		message: '',

        // selected fields
		expected_certificates : [],
		pharmacopoeia_grades : [],
	}
	const [showProductResults, setShowProductResults] = useState(false);
	const [productString, setProductString] = useState('');
	const [casNumber, setCasNumber] = useState('');
	const [showEnquiryModal, setShowEnquiryModal] = useState(false);

	const dispatch : any = useDispatch();
	const { 
		values, 
		errors,  
		touched, 
		handleBlur, 
		handleChange, 
		handleSubmit, 
		resetForm,
		setFieldValue
	} = useFormik({
		initialValues : initialValues,
		validationSchema : ShortEnquiryFormSchema,

		onSubmit : (values : any) => {
			
			const payload = {...values};
			payload['attachment'] = files.length ? files[0].id : null;

			// In case a Product String is there but not selected any predefined product.
			if(payload.product_string !== '' && payload.product === null) {
				payload.product_text = payload.product_string;
				setFieldValue('product_text', payload.product_string)
			}

			if(user.isLoggedIn) {
				dispatch(submitEnquiry(payload));
			}
			else {
				dispatch(openEnquiryModal(payload));
				setShowEnquiryModal(true);
			}
		} 
	});
	const {
		apiList, 
		countryList,
		enquiryState,
		files
	} = useSelector((state : any) => state.core);
	const { user } = useSelector((state : any) => state.auth);

	useEffect(() => {
		dispatch(getCertificateList());
		dispatch(getPharmacopoeiaGrades());
	}, []);

	useEffect(() => {
		if (enquiryState.showSuccessModal) {
			resetEnquiryForm();
		}
	}, [enquiryState.showSuccessModal])

	// FUNCTIONS
	const handleProductSearch = (event : any) => {
		setProductString(() => event.target.value);
		setFieldValue('product_string', event.target.value);
		setShowProductResults(true);
		const params = {
			page: 1,
			page_size: 5,
			search: event.target.value
		}
		dispatch(getAPIList(params));

		if(event.target.value == '') {
			setFieldValue('product', null);
		}
	} 

	const selectProduct = (data : any) => {
		setProductString(() => data.name);
		setCasNumber(() => data.cas_number);
		setFieldValue('product_string', data.name);
		setFieldValue('product', data.id);
		setShowProductResults(false);
	}

	const handleProductClear = () => {
		setProductString(() => '');
		setFieldValue('product_string', '');
		setFieldValue('product', null);
		setCasNumber(() => '')
	}

	const resetEnquiryForm = () => {
		resetForm();
		setProductString('');
		dispatch(setFileData({
			data : [],
			action : 'replace'
		}));
	}	

	return (
		<>
			<div id='enquiry-section' className='pb-10 min-h-[300px] relative lg:flex justify-between items-center --align overflow-x-hidden py-[40px] lg:py-[70px]'>
				<img className='hidden md:inline-block absolute top-[80px] -left-[60px] z-0' src={'/Home/Ellipse.svg'} width={300} height={100} alt="" />
				<img className='hidden md:inline-block absolute bottom-[100px] -right-[100px] -z-9' src={'/Home/Ellipse.svg'} width={300} height={100} alt="" />


				<div className={`text-theme-dark-saffron text-left mb-8 lg:w-[40%] relative`} >
					<h1 className='text-3xl font-semibold -mb-4 lg:-mb-0 md:text-2xl lg:text-[2.9rem]'> {firstHeading} </h1>
					<h1 className='text-3xl font-semibold pt-5 md:text-2xl lg:text-[2.9rem] mb-3'> {secondHeading} </h1>
					<h2 className='text-sm lg:text-xl text-theme-blue'> {subText} </h2>
					<div className='text-sm lg:text-lg mt-8'>
					<div className='flex mb-[6px]'>
							<img src="/Home/Call.svg" alt="" className='w-[29px] h-[29px] mr-[9px]' />
							<p className='text-theme-dark-saffron'>+91-8655735634</p> 
						</div>

						<div className='flex'>
							<img src="/Home/Email.svg" alt="" className='w-[29px] h-[29px] mr-[9px]' />
							<p className='text-theme-dark-saffron'>support@apidrug.com</p> 
						</div>

					</div>
				</div>

				<form 
					id='enquiry-form'
					onSubmit={handleSubmit} 
					className={`
                                relative 
                                z-1 
                                bg-[#FEF7F5] 
                                grid 
                                grid-cols-1 
								rounded-[5px]
                                gap-4 
                                md:grid-cols-2 
                                lg:grid-cols-4
                                gap-y-4
								p-5
                                lg:p-[30px]
                                lg:w-[70%]
                            `}
				>				
					<div className='lg:col-span-2 relative'>
						<Input
							label='Product'
                            labelColor = '#305399'
							placeholder='eg. Paracetamol'
							search
							name = 'product_string'
							onInput={handleProductSearch}
							value={productString}
							background='#FEF7F5'
							color='#314783'
							outerProperties={`rounded ${!productString && 'py-[11.5px]'} border border-[#0000001a]`}
							error={errors.product_string}
							touched={touched.product_string}
							onBlur = {(e : any) => {
								setTimeout(() => {
									setShowProductResults(() => false);
									handleBlur(e)
								}, 300);
							}}
							searchResults={
								showProductResults &&
								apiList.list.map((data: any, index: number) => (
									<div className="
											flex 
											justify-between 
											text-[12px] 
											my-1 
											py-2 
											text-theme-black 
											font-light 
											cursor-pointer 
											rounded 
											items-center 
											hover:bg-[#D4D9E7]/50 
											font-semibold"
										onClick={() => selectProduct(data)}
										key={index}
									>
										<p className="flex flex-col font-light">
											<span>
												{data.name} ({data.cas_number})
											</span>
											<small> {data.product_type} </small>
										</p>
									</div>
								))
							}
							suffix={
								productString &&
								<div onClick={handleProductClear} className='cursor-pointer text-theme-blue p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
									</svg>
								</div>
							}
						/>
						{
							casNumber ?
							<small className='text-[#9ca3af] inline-block mt-2 opacity-70'> CAS # { casNumber } </small>
							:
							<small className='text-[#9ca3af] inline-block mt-2 opacity-70'> CAS # will be auto populated </small> 
						}
					</div>

					<div className='w-full ml-auto lg:col-span-2'>
						<Input
							className='mb-3'
							label='Quantity'
                            labelColor = '#305399'
							placeholder='eg. 10'
                            background='#FEF7F5'
							color='#314783'
							outerProperties='rounded py-0.5 border border-[#0000001a]'
							suffix={
								<StyledQuantitySuffix className='text-white bg-theme-blue m-1 text-sm flex justify-center items-center'>
									KG
								</StyledQuantitySuffix>
							}
							onChange={handleChange}
							name='quantity'
							value={values.quantity}
							onBlur={handleBlur}
							error={errors.quantity}
							touched={touched.quantity}
						/>
					</div>

					
					<div className='col-span-full'>
						<TextArea
							outerProperties='w-full mt-3 pt-3 rounded placeholder:text-sm placeholder:font-light border border-[#0000001a]'
							rows={4}
							background = '#FEF7F5'
							color = '#314783'
							placeholder="Add your required target price, make, quality certificates, delivery date, delivery country etc.."
							onChange={handleChange}
							name='message'
							value={values.message}
							onBlur={handleBlur}
							error={errors.message}
							touched={touched.message}
						/>
					</div>

					<Button 
						styles='w-full text-white bg-theme-orange h-12 lg:w-[150px]'
						destinationEvent = ""
					> 
						Submit 
					</Button>
				</form>
			</div>

			<EnquiryForm
				show = {showEnquiryModal}
				data={values}
				payload={values}
				countryList={countryList.fixedList}
				onClose = {() => setShowEnquiryModal(false)}
			/>

			<EnquirySuccess
				show={enquiryState.showSuccessModal}
				user={enquiryState.responseData ? enquiryState.responseData.user : ''}
			/>
		</>
	)
}

ShortEnquiry.defaultProps = {
	firstHeading : "Didn't find what",
	secondHeading : "you're looking for?",
	subText : 'Share your requirement with us and we will find the best deal for you'
}

export default ShortEnquiry